import PropTypes from 'prop-types'
import styled from 'styled-components'

import colors from 'components/utils/colors'

const StyledModalFooter = styled.div`
  display: flex;
  padding: 48px 32px 48px 32px;
  border-top: 1px solid ${colors.secondary95};
  position: relative;
  justify-content: flex-end;

  & > * {
    margin-left: 8px;
  }

  & > :first-child { {
    margin-left: 0;
  }
`

const ModalFooter = ({ children }) => {
  return (
    <StyledModalFooter>
      {children}
    </StyledModalFooter>
  )
}

ModalFooter.propTypes = {
  children: PropTypes.node,
}

export default ModalFooter
